<template>

    <Card :dis-hover="true">
        <BinFenSeedFarmUserList />
    </Card>
</template>

<script>
import BinFenSeedFarmUserList from './../../account-management/binFenSeedFarm-user-management/binFenSeedFarm-user-list';

export default {
    name: 'UserList',
    components: {
        BinFenSeedFarmUserList
    },
    data() {
        return {
            userType: "admin"
        };
    },
    mounted() {
    },
    methods: {
    }
};
</script>

<style scoped>
</style>
